import React, { ChangeEventHandler, useEffect, useState } from "react";
import { PanelProperty } from "../types";
import classes from "../../../utils/HTML/classes";
import useDebounce from "../../../hooks/useDebounce";

export type TextareaPropertyProps = PanelProperty<unknown> & {
  value: string;
  onChange: (value: string) => void;
};

export const TextareaProperty = ({ value, onChange, readOnly, disabled, className }: TextareaPropertyProps) => {
  const [inputValue, setInputValue] = useState<string>(value);
  const debouncedInputValue = useDebounce(inputValue, 250);

  const handleInputChange: ChangeEventHandler<HTMLTextAreaElement> = (event) => {
    setInputValue(event.target.value);
  };

  useEffect(() => {
    onChange?.(debouncedInputValue);
  }, [debouncedInputValue]);

  return (
    <textarea
      className={classes("property-field-textarea", className)}
      defaultValue={value}
      onChange={handleInputChange}
      disabled={disabled}
      readOnly={readOnly}
    />
  );
};
